import { For, Show, type JSX } from 'solid-js';
import { describeError } from '../lib/errors';
import { dismissToast, toasts } from '../lib/toast';
import { Button, IconButton } from '../ui/Button';
import { Icon, type IconName } from '../ui/Icon';

export function EmptyState(props: {
  icon?: IconName;
  title: string;
  text?: string;
  action?: JSX.Element;
}): JSX.Element {
  return (
    <div class="state">
      <div class="state__icon">
        <Icon name={props.icon ?? 'inbox'} size={22} />
      </div>
      <div class="state__title">{props.title}</div>
      <Show when={props.text}>
        <p class="state__text">{props.text}</p>
      </Show>
      {props.action}
    </div>
  );
}

export function ErrorAlert(props: {
  title?: string;
  error: unknown;
  /** Replaces the generic text when the caller knows what the failure means. */
  message?: string;
  onRetry?: () => void;
}): JSX.Element {
  return (
    <div class="alert alert--danger">
      <Icon name="alert" size={18} />
      <div class="alert__body">
        <span class="alert__title">{props.title ?? 'Something went wrong'}</span>
        <span>{props.message ?? describeError(props.error)}</span>
      </div>
      <Show when={props.onRetry}>
        <Button variant="secondary" size="sm" onClick={() => props.onRetry?.()}>
          Retry
        </Button>
      </Show>
    </div>
  );
}

export function LoadingRows(props: { rows?: number; height?: number }): JSX.Element {
  return (
    <div class="list">
      <For each={Array.from({ length: props.rows ?? 3 })}>
        {() => <div class="skeleton" style={{ height: `${props.height ?? 96}px` }} />}
      </For>
    </div>
  );
}

export function Toaster(): JSX.Element {
  return (
    <div class="toasts">
      <For each={toasts()}>
        {(toast) => (
          <div class={`toast toast--${toast.kind}`}>
            <div class="toast__body">{toast.text}</div>
            <IconButton label="Dismiss" small onClick={() => dismissToast(toast.id)}>
              <Icon name="close" size={14} />
            </IconButton>
          </div>
        )}
      </For>
    </div>
  );
}
